import { Component, OnInit } from '@angular/core';
import { ButtonConfig } from '../shared.interface';
import {
    APPLICATION_STATUS,
    DataTableConfig,
    DOCUMENT_VALIDITY,
    DOCUMENT_VALIDITY_BY_DURATION,
    SELECT_TABLE_ROW_STATUS,
} from '../shared.interface';

@Component({
    selector: 'app-demo',
    templateUrl: './demo.component.html',
    styleUrls: ['./demo.component.scss'],
})
export class DemoComponent implements OnInit {
    active = 3;

    buttons: ButtonConfig[] = [
        {
            label: 'Νέα Αγοραπωλησία',
            actionCallback: this.test1,
        },

        {
            label: 'Νέα Αγοραπωλησία',
            actionCallback: this.test1,
            classes: ['btn-danger'],
        },
        {
            label: 'Νέα Αγοραπωλησία',
            actionCallback: this.test1,
            disabled: true,
        },
        {
            label: 'Προβολή/Επεξεργασία',
            actionCallback: this.test1,
            classes: ['table-btn'],
        },

        {
            label: 'Προβολή/Επεξεργασία',
            actionCallback: this.test1,
            classes: ['table-btn'],
            disabled: true,
        },
    ];
    constructor() {}

    ngOnInit(): void {
        setTimeout(() => {
            this.buttons[0].label = 'new name';
        }, 3000);
    }

    test1() {
        console.log('[DemoComponent] test1');
    }

    imgPath = 'assets/images/file-icon.png';
    sectionTitle =
        'Εύρεση ακινήτου με βάση τον αριθμό υποβολής μισθωτηρίου και το έτος.';
    altText = 'papyrus icon for table title';

    grayBg = {
        backgroundColor: '#F5F5F5',
        rowColor: '#FFFFFF',
    };

    whiteBg = {
        backgroundColor: '#FFFFFF',
        rowColor: '#F5F5F5',
    };

    whiteBgBlueRows = {
        backgroundColor: '#FFFFFF',
        rowColor: '#EAF8FD',
    };

    // table6a: DataTableConfig = {
    //     headers: {
    //         documentTitle: 'Τίτλος Εγγράφου',
    //         documentValidityDuration: 'Διάρκεια ισχύος Εγγράφου',
    //         documentValidityByDuration: 'Εγκυρότητα ισχύος Εγγράφου',
    //         documentCheckedByNotary: 'Έλεγχος Εγγράφου από Συμβολαιογράφο',
    //         refreshEnabled: '',
    //         action: 'Ενέργεια',
    //     },
    //     data: [
    //         {
    //             documentTitle: 'Συμβόλαιο Ακινήτου',
    //             documentValidityDuration: '-',
    //             documentValidityByDuration:
    //                 DOCUMENT_VALIDITY_BY_DURATION.notChecked,
    //             documentCheckedByNotary: true,
    //             refreshEnabled: false,
    //             action: ['Προβολή/Επεξεργασία', 'Μεταφόρτωση'],
    //         },
    //         {
    //             documentTitle: 'Πιστοποιητικό ΕΝΦΙΑ',
    //             documentValidityDuration: 'Μέχρι την 31/12 του έτους έκδοσης',
    //             documentValidityByDuration: DOCUMENT_VALIDITY_BY_DURATION.expired,
    //             documentCheckedByNotary: false,
    //             refreshEnabled: true,
    //             action: ['Προβολή/Επεξεργασία'],
    //         },
    //         {
    //             documentTitle: 'Αποδεικτικό Ασφαλιστικής Ενημερότητας',
    //             documentValidityDuration:
    //                 'α) Έξι (6) μήνες, αν δεν υφίσταται οφειλή ή πέντε (5) μήνες, αν δεν υφίσταται οφειλή',
    //             documentValidityByDuration: DOCUMENT_VALIDITY_BY_DURATION.valid,
    //             documentCheckedByNotary: true,
    //             refreshEnabled: false,
    //             action: ['Προβολή/Επεξεργασία'],
    //         },
    //     ],
    // };

    // table4a = {
    //     headers: {
    //         requestNumber: 'Κωδικός Αιτήματος',
    //         buyersAfm: 'ΑΦΜ Αγοραστή/ών',
    //         sellersAfm: 'ΑΦΜ Πωλητή/ών',
    //         submissionDate: 'Ημερομηνία Υποβολής',
    //         documentValidity: 'Εγκυρότητα Εγγράφων',
    //         applicationStatus: 'Κατάσταση Αίτησης',
    //         action: 'Ενέργεια',
    //     },
    //     data: [
    //         {
    //             requestNumber: '123456',
    //             buyersAfm: ['12345678912'],
    //             sellersAfm: ['12345678911'],
    //             submissionDate: '12/09/2020',
    //             documentValidity: DOCUMENT_VALIDITY.valid,
    //             applicationStatus: APPLICATION_STATUS.inProgress,
    //             action: ['Προβολή/Επεξεργασία'],
    //         },
    //         {
    //             requestNumber: '123457',
    //             buyersAfm: ['12345678913'],
    //             sellersAfm: ['12345678914'],
    //             submissionDate: '13/09/2020',
    //             documentValidity: DOCUMENT_VALIDITY.inValid,
    //             applicationStatus: APPLICATION_STATUS.awaitingActionFromSeller,
    //             action: ['Προβολή/Επεξεργασία', 'Προβολή'],
    //         },
    //         {
    //             requestNumber: '123458',
    //             buyersAfm: ['12345678915', '12345678944'],
    //             sellersAfm: ['12345678911'],
    //             submissionDate: '03/09/2020',
    //             documentValidity: DOCUMENT_VALIDITY.notChecked,
    //             applicationStatus: APPLICATION_STATUS.newRequest,
    //             action: ['Προβολή/Επεξεργασία'],
    //         },
    //     ],
    // };

    table1Data = [
        {
            headers: [
                {
                    requestNumber: 'Κωδικός Αιτήματος',
                    buyersAfm: 'ΑΦΜ Αγοραστή',
                    buyersName: 'Ονοματεπώνυμο Αγοραστή',
                    sellersAfm: 'ΑΦΜ Πωλητή',
                    sellerName: 'Ονοματεπώνυμο Πωλητή',
                    submissionDate: 'Ημερομηνία Υποβολής',
                },
            ],
            data: [
                {
                    requestNumber: '123456',
                    buyersAfm: '12345678911',
                    buyersName: 'Παπαδόπουλος Αντώνιος',
                    sellersAfm: '12345678912',
                    sellerName: 'Σαλίογλου Μαριάννα',
                    submissionDate: '12/09/2020',
                },
            ],
        },
    ];

    table2Data = [
        {
            headers: [
                {
                    fullName: 'Ονοματεπώνυμο',
                    idNumber: 'Αριθμός Ταυτότητας',
                    fathersName: 'Όνομα Πατρός',
                    birthday: 'Ημερομηνία Γέννησης',
                    idIssuingAuthority: 'Αρχή Έκδοσης Δελτίου Ταυτότητας',
                    occupation: 'Επάγγελμα',
                },
            ],
            data: [
                {
                    fullName: 'Παπαδόπουλος Αντώνιος',
                    idNumber: 'ΑΒ 12345',
                    fathersName: 'Μάρκος',
                    birthday: '13/12/1965',
                    idIssuingAuthority: 'Α.Τ. Γιαννιτσών',
                    occupation: 'Δημόσιος Υπάλληλος',
                },
            ],
        },
    ];

    table3Data = [
        {
            cardHeader: 'Στοιχεία αγοραστή με ΑΦΜ : 12345678911',
            headers: [
                {
                    fullName: 'Ονοματεπώνυμο',
                    idNumber: 'Αριθμός Ταυτότητας',
                    fathersName: 'Όνομα Πατρός',
                    birthday: 'Ημερομηνία Γέννησης',
                    idIssuingAuthority: 'Αρχή Έκδοσης Δελτίου Ταυτότητας',
                    occupation: 'Επάγγελμα',
                },
                {
                    homeAddress: 'Διεύθυνση Κατοικίας',
                    homeZipCode: 'Τ.Κ. Κατοικίας',
                    incomeDoy: 'Δ.Ο.Υ. Εισοδήματος',
                    familyState: 'Οικογενειακή Κατάσταση',
                },
            ],
            data: [
                {
                    fullName: 'Παπαδόπουλος Αντώνιος',
                    idNumber: 'ΑΒ 12345',
                    fathersName: 'Μάρκος',
                    birthday: '13/12/1965',
                    idIssuingAuthority: 'Α.Τ. Γιαννιτσών',
                    occupation: 'Δημόσιος Υπάλληλος',
                },
                {
                    homeAddress: 'Γεωργίου Αβέρωφ 12, Έδεσσα, Ν.Πέλλας',
                    homeZipCode: '58200',
                    incomeDoy: 'Εδέσσης',
                    familyState: 'Έγγαμος',
                },
            ],
        },
        {
            cardHeader: 'Στοιχεία πωλητή  με ΑΦΜ : 12345678912',
            headers: [
                {
                    fullName: 'Ονοματεπώνυμο',
                    idNumber: 'Αριθμός Ταυτότητας',
                    fathersName: 'Όνομα Πατρός',
                    birthday: 'Ημερομηνία Γέννησης',
                    idIssuingAuthority: 'Αρχή Έκδοσης Δελτίου Ταυτότητας',
                    occupation: 'Επάγγελμα',
                },
                {
                    homeAddress: 'Διεύθυνση Κατοικίας',
                    homeZipCode: 'Τ.Κ. Κατοικίας',
                    incomeDoy: 'Δ.Ο.Υ. Εισοδήματος',
                    familyState: 'Οικογενειακή Κατάσταση',
                },
            ],
            data: [
                {
                    fullName: 'Σαλίογλου Μαριάννα',
                    idNumber: 'ΟΟ 12345',
                    fathersName: 'Ευτύχιος',
                    birthday: '09/01/1990',
                    idIssuingAuthority: 'Α.Τ. Γιαννιτσών',
                    occupation: 'Δικηγόρος',
                },
                {
                    homeAddress: 'Αρχαγγέλου Μιχαήλ 22, Έδεσσα, Ν.Πέλλας',
                    homeZipCode: '58200',
                    incomeDoy: 'Εδέσσης',
                    familyState: 'Έγγαμος',
                },
            ],
        },
    ];

    // table9c: DataTableConfig = {
    //     tableClasses: 'table-select',
    //     rowClickCallback: this.onRowClick.bind(this),
    //     headers: {
    //         buildingAddress: 'Διεύθυνση Ακινήτου',
    //         ownerFullName: 'Ονοματεπώνυμο Ιδιοκτήτη'
    //     },
    //     data: [
    //         {
    //             buildingAddress: 'Εγνατίας 67, Θεσσαλονίκη, Ν.Θεσσαλονίκης',
    //             ownerFullName: 'Παπαδόπουλος Αντώνιος',
    //             rowSelected: SELECT_TABLE_ROW_STATUS.notChecked
    //         },
    //         {
    //             buildingAddress: 'Αγίας Τριάδας 33, Θεσσαλονίκη, Ν.Θεσσαλονίκης',
    //             ownerFullName: 'Παπαδόπουλος Αντώνιος',
    //             rowSelected: SELECT_TABLE_ROW_STATUS.notChecked
    //         },
    //         {
    //             buildingAddress: 'Εγνατίας 67, Θεσσαλονίκη, Ν.Θεσσαλονίκης',
    //             ownerFullName: 'Παπαδόπουλος Αντώνιος',
    //             rowSelected: SELECT_TABLE_ROW_STATUS.notChecked
    //         }
    //     ]
    // }

    onRowClick(index) {
        console.log(`row ${index} clicked`);
        // this.table9c.data.map(row => row.rowSelected = SELECT_TABLE_ROW_STATUS.notSelected);
        // this.table9c.data[index].rowSelected = SELECT_TABLE_ROW_STATUS.selected;
    }
}
